import React from 'react';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';
import {FormFieldsProps} from '../../@types/components/Form';
import FormFields from '../Form/FormFields';

export default function NestedFormFields<Model extends IEmptyModel>(props: FormFieldsProps<Model>) {
    return <FormFields {...props}/>;
}
